import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { TourProvider } from "@/contexts/TourContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import { PwaPrompt } from "@/components/PwaPrompt";
import { OnboardingTour } from "@/components/OnboardingTour";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import SetPasswordPage from "@/pages/SetPasswordPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientDashboard from "@/pages/ClientDashboard";
import ClientsListPage from "@/pages/ClientsListPage";
import ClientDetailPage from "@/pages/ClientDetailPage";
import ProjectsListPage from "@/pages/ProjectsListPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import NotificationsPage from "@/pages/NotificationsPage";
import AuditPage from "@/pages/AuditPage";
import SettingsPage from "@/pages/SettingsPage";
import UsersPage from "@/pages/UsersPage";
import ClientUsersPage from "@/pages/ClientUsersPage";
import ClientGuidePage from "@/pages/ClientGuidePage";

function HomeSwitch() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return user.role === "ADMIN" ? <AdminDashboard /> : <ClientDashboard />;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <TourProvider>
            <Toaster richColors position="bottom-right" />
            <PwaPrompt />
            <OnboardingTour />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/set-password" element={<SetPasswordPage />} />

              <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                <Route path="/" element={<HomeSwitch />} />
                <Route path="/clients" element={<ProtectedRoute roles={["ADMIN"]}><ClientsListPage /></ProtectedRoute>} />
                <Route path="/clients/:id" element={<ProtectedRoute roles={["ADMIN"]}><ClientDetailPage /></ProtectedRoute>} />
                <Route path="/projects" element={<ProjectsListPage />} />
                <Route path="/projects/:id" element={<ProjectDetailPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/audit" element={<ProtectedRoute roles={["ADMIN"]}><AuditPage /></ProtectedRoute>} />
                <Route path="/settings" element={<ProtectedRoute roles={["ADMIN"]}><SettingsPage /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute roles={["ADMIN"]}><UsersPage /></ProtectedRoute>} />
                <Route path="/client-users" element={<ProtectedRoute roles={["CLIENT"]}><ClientUsersPage /></ProtectedRoute>} />
                <Route path="/guide" element={<ProtectedRoute roles={["CLIENT"]}><ClientGuidePage /></ProtectedRoute>} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </TourProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
